import React from 'react';
import { Table } from 'react-bootstrap';
import FormOverlay from '../../../../components/Overlay';

const ActionsPopup = ({ actions, onHide }) => {
    const rows = actions.map(action => <tr>
        <td>{action.param}</td>
        <td>{action.value}</td>
        <td>{action.prevValue}</td>
    </tr>);

    return (
        <FormOverlay onFormHide={onHide}>
            <Table bordered responsive>
                <thead>
                    <tr>
                        <th>Param</th>
                        <th>Value</th>
                        <th>Previous Value</th>
                    </tr>
                </thead>
                <tbody>
                    {rows}
                </tbody>
            </Table>
        </FormOverlay>
    );
}

export default ActionsPopup;


// WEBPACK FOOTER //
// ./src/scenes/History/components/ActionsPopup/index.js